import { Component, Prop, Vue } from 'vue-property-decorator';
import { allowMemberReserveBeyondTerm, currentMembership, isCurrentOrPastMember, membershipOnDate, } from '@/state/Membership';
@Component({ name: 'RenewMembershipMessage' })
export default class default_1 extends Vue {
    @Prop({ required: true })
    event;
    @Prop({ required: true })
    // TODO Use TixDate instead.
    dateToCheck;
    get eventHasMembersTickets() {
        return (this.event.hidden_type === 'public_member_only' ||
            this.event.ticketGroups.some((group) => group.hidden_type === 'public_member_only'));
    }
    get membershipExpiredByDate() {
        if (isCurrentOrPastMember()) {
            if (allowMemberReserveBeyondTerm()) {
                return false;
            }
            else {
                return membershipOnDate(this.dateToCheck) === undefined;
            }
        }
        else {
            return false;
        }
    }
    get getMembershipRenewalMessage() {
        if (this.eventHasMembersTickets && this.membershipExpiredByDate) {
            const current = currentMembership();
            const dateFormat = this.$t('dateFormat.medium');
            const ticketDate = this.dateToCheck.format(dateFormat);
            if (current) {
                const expiryDate = current.validTo.format(dateFormat);
                return this.expiresInMessage(expiryDate, ticketDate);
            }
            else {
                return this.expiredMessage(ticketDate);
            }
        }
        else {
            return null;
        }
    }
    expiresInMessage(expiryDate, ticketDate) {
        return this.$t('renewMembershipMessage.expiresIn', {
            expiryDate,
            ticketDate,
        });
    }
    expiredMessage(ticketDate) {
        return this.$t('renewMembershipMessage.expired', {
            ticketDate,
        });
    }
}
